import { TransferListItem } from './types';

export function not(a: TransferListItem[], b: TransferListItem[]) {
  const bIds = b.map((item) => item.id);
  return a.filter((item) => !bIds.includes(item.id));
}

export function intersection(a: TransferListItem[], b: TransferListItem[]) {
  const bIds = b.map((item) => item.id);
  return a.filter((item) => bIds.includes(item.id));
}

export const getIndex = (items: TransferListItem[], value: TransferListItem) => {
  return items.findIndex((item) => item.id === value.id);
};
